import * as Loadable from 'react-loadable'

import {
  fetchHomePageDataBySite,
  onBeforeHomePageView
} from '../../../common/actions/homePage'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'

const HomePageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "homePage" */ './homePageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./homePageContainer')],
  modules: ['./homePageContainer']
}) as IPageComponent<any>

HomePageLoadableContainer.loadData = ({
  store,
  location,
  apiUrlPrefix,
  apiAppUrlPrefix
}) =>
  store.dispatch(
    fetchHomePageDataBySite({ location, apiUrlPrefix, apiAppUrlPrefix })
  )

HomePageLoadableContainer.onBeforePageView = ({ store }) =>
  store.dispatch(onBeforeHomePageView())

export default HomePageLoadableContainer
